<template>
    <div class="relative" v-click-away="onClickAway">
      <div  @click="toggle">
        <slot name="trigger"></slot>
      </div>

      <transition
        enter-active-class="duration-300 ease-out"
        enter-from-class="transform opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="transform opacity-0"
      >
        <div
          v-show="show"
          class="absolute right-0 lg:right-auto lg:left-0 top-full mt-2.5 w-[200px] rounded-xl bg-white p-5 shadow-search"
        >
          <slot
            name="content"
            class="absolute left-0 top-full w-full bg-white shadow-search"
          ></slot>
        </div>
      </transition>
    </div>
  </template>

  <script>
  export default {
    name: 'DropdownSm',

    data() {
      return {
        show: false,
      }
    },

    methods: {
      toggle() {
        this.show = !this.show;
        this.show ? this.$emit('open', this.show) : this.$emit('close', this.show)
      },

      onClickAway(event) {
        this.show = false;
        this.$emit('close', this.show)
      },
    }
  }
  </script>
